import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {states} from "./states.data";
import {StateModel} from "../../models/state.model";

@Injectable()
export class StateService {

  constructor() {
  }


  get(): Observable<Array<StateModel>> {
    return new Observable((observer) => {
      console.log("States being retrieved");
      observer.next(states);
    });

  }

}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/state/state.service.ts